import React from 'react';

import {
  StyledImageContainer,
  StyledMarker,
  StyledMarkerArea,
  StyledSoundPlayer,
} from './styled';

type SoundPlayerProps = {
  audioUrl?: string;
  imgUrl: string;
  times?: any;
};

const SoundPlayer = React.forwardRef(
  (props: SoundPlayerProps, ref: React.ForwardedRef<HTMLAudioElement>) => {
    const { audioUrl, imgUrl, times } = props;
    const [currentTime, setCurrentTime] = React.useState(0);
    const [isPlaying, setIsPlaying] = React.useState(false);

    const soundPlayerRef = React.createRef<HTMLDivElement>();

    const showRangeProgress = (input: any) => {
      const audio = soundPlayerRef.current?.childNodes[1];
      if (audio) {
        // @ts-ignore
        audio.currentTime =
          (input.value / input.max) * parseFloat(times['duration-s']);
        // @ts-ignore
        audio.play();
      }

      setCurrentTime((input.value / input.max) * 100);
    };

    const onTimeUpdate = (e: React.SyntheticEvent<HTMLAudioElement>) => {
      // @ts-ignore
      if (e.target.currentTime !== 0) {
        setIsPlaying(true);
      }
      // @ts-ignore
      setCurrentTime((e.target.currentTime / e.target.duration) * 100);
    };

    return (
      <StyledSoundPlayer ref={soundPlayerRef}>
        <StyledImageContainer>
          {times && (
            <StyledMarkerArea
              className="swiper-no-swiping"
              start={parseFloat(times['audio-start-xpos-percent'])}
              end={parseFloat(times['audio-end-xpos-percent'])}
            >
              <StyledMarker
                className="swiper-no-swiping"
                isPlaying={isPlaying}
                style={{
                  left: `calc(${currentTime}%)`,
                }}
              />
              <input
                type="range"
                onInput={(event) => showRangeProgress(event.target)}
                max={100}
                value={currentTime}
              />
            </StyledMarkerArea>
          )}
          <img src={imgUrl} alt=" " />
        </StyledImageContainer>
        {audioUrl && (
          // eslint-disable-next-line jsx-a11y/media-has-caption
          <audio
            src={audioUrl}
            {...(times ? { onTimeUpdate } : {})}
            onPause={() => setIsPlaying(false)}
            controls
            ref={ref}
          />
        )}
      </StyledSoundPlayer>
    );
  },
);

export default SoundPlayer;
